import { render, staticRenderFns } from "./smsaliyun.vue?vue&type=template&id=3c96418a"
import script from "./smsaliyun.vue?vue&type=script&lang=js"
export * from "./smsaliyun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports